
import React from "react";
import { Button } from "@/components/ui/button";
import { Loader2, Check, AlertCircle } from "lucide-react";

interface ProfileFormActionsProps {
  savingState: 'idle' | 'saving' | 'saved' | 'error';
  uploading: boolean;
  isProfileComplete?: boolean;
}

const ProfileFormActions: React.FC<ProfileFormActionsProps> = ({
  savingState,
  uploading,
  isProfileComplete = false,
}) => {
  return (
    <div className="pt-4 flex items-center justify-between">
      <div className="flex items-center text-sm">
        {savingState === 'saving' || uploading ? (
          <div className="flex items-center text-primary">
            <Loader2 className="mr-2 h-4 w-4 animate-spin" />
            <span>Saving changes...</span>
          </div>
        ) : savingState === 'saved' ? (
          <div className="flex items-center text-green-600">
            <Check className="mr-2 h-4 w-4" />
            <span>Changes saved</span>
          </div>
        ) : savingState === 'error' ? (
          <div className="flex items-center text-destructive">
            <AlertCircle className="mr-2 h-4 w-4" />
            <span>Error saving changes</span>
          </div>
        ) : null}
      </div>

      <Button type="submit" disabled={uploading}>
        {isProfileComplete ? "Continue to Network" : "Save Profile"}
      </Button>
    </div>
  );
};

export default ProfileFormActions;
